// Chuẩn hoá HTML soạn bằng Quill TRƯỚC KHI gửi thử / lưu chiến dịch email.
//
// Email client KHÔNG nạp CSS của Quill, nên mọi thứ Quill thể hiện bằng CLASS
// đều mất tác dụng, phải đổi sang style inline:
//   - class ql-align-center|right|justify  -> style="text-align:..."
//   - <p> mặc định có margin ở đa số client -> giãn dòng đôi khi bấm Enter
// Ngoài ra dùng chung normalizeQuillHtml: list chuẩn (<ul>/<ol>) + bỏ &nbsp;
// (Quill 2 mã hoá MỌI dấu cách thành &nbsp; -> đoạn văn không ngắt dòng được).
import { normalizeQuillHtml } from "../../../utils/quill-html-normalize";

const ALIGN_RE = /ql-align-(left|center|right|justify)/;
// Tab "HTML" cho phép dán nguyên một template email hoàn chỉnh. Đưa chuỗi đó
// qua DOMParser sẽ nuốt mất <html>/<head>/<body> -> để nguyên, không đụng vào.
const FULL_DOC_RE = /<(html|head|body)\b/i;

/**
 * @param {string} html HTML lấy từ editor (hoặc tab HTML)
 * @returns {string} HTML an toàn cho email client
 */
export function normalizeEmailHtml(html) {
    if (!html || typeof html !== "string") return html;
    if (FULL_DOC_RE.test(html)) return html;

    const cleaned = normalizeQuillHtml(html);
    if (typeof window === "undefined" || !window.DOMParser) return cleaned;

    const doc = new DOMParser().parseFromString(`<div id="root">${cleaned}</div>`, "text/html");
    const root = doc.getElementById("root");
    if (!root) return cleaned;

    root.querySelectorAll('[class*="ql-align-"]').forEach((el) => {
        const match = (el.getAttribute("class") || "").match(ALIGN_RE);
        if (!match) return;
        el.style.textAlign = match[1];
        el.classList.remove(match[0]);
        if (!el.getAttribute("class")) el.removeAttribute("class");
    });

    root.querySelectorAll("p").forEach((p) => {
        p.style.margin = "0";
        p.style.padding = "0";
    });

    // An toàn: relaxNbsp đã chạy trước nên không còn U+00A0 để innerHTML mã
    // hoá ngược thành &nbsp;.
    return root.innerHTML;
}
